"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlSafeBase64Decode = exports.urlSafeBase64Encode = void 0;
/**
 * @jest-environment jsdom
 */
const base64_1 = require("./base64");
const urlSafeBase64Encode = (unencoded) => (0, base64_1.base64EncArr)(unencoded)
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
exports.urlSafeBase64Encode = urlSafeBase64Encode;
//  .replace('+', '-').replace('/', '_').replace(/=+$/, '');
const urlSafeBase64Decode = (encoded) => {
    encoded = encoded
        .replace(/\-/g, "+")
        .replace(/_/g, "/");
    while (encoded.length % 4)
        encoded += '=';
    return (0, base64_1.base64DecToArr)(encoded);
};
exports.urlSafeBase64Decode = urlSafeBase64Decode;
//# sourceMappingURL=encodings.js.map